import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Loading } from '../loading/loading.component.js';
import { Text } from '../text/text.component.js';
import { GoogleIcon, GoogleIconGray } from './google-button.icon.js';
import { StyledGoogleButton, ContentWrapper } from './google-button.style.js';

const GoogleButton = props => {
    const { className = '', children, disabled = false, fullWidth = false, loading = false, margin, onClick } = props, rest = __rest(props, ["className", "children", "disabled", "fullWidth", "loading", "margin", "onClick"]);
    const getContent = () => (jsxs(ContentWrapper, { children: [!disabled ? jsx(GoogleIcon, {}, void 0) : jsx(GoogleIconGray, {}, void 0), jsx(Text, Object.assign({ textStyle: "heading500", opacity: "medium" }, { children: children }), void 0)] }, void 0));
    return (jsx(StyledGoogleButton, Object.assign({ className: className, fullWidth: fullWidth, margin: margin, disabled: disabled || loading, onClick: onClick, openInNewTab: false }, rest, { children: loading ? (jsx(ContentWrapper, { children: jsx(Loading, {}, void 0) }, void 0)) : (getContent()) }), void 0));
};

export { GoogleButton };
